// extracted by mini-css-extract-plugin
export default {"container":"deleteIconButton_container__Ggz40","icon":"deleteIconButton_icon__-l-UB","disabled":"deleteIconButton_disabled__bcrbS"};